import React from "react";
import { Button, Radio, RadioChangeEvent } from "antd";
import { NotificationItem } from "@Components/notifications/NotificationItem";
import { NotificationItemAction, NotificationsFilter } from "@Components/shared/Notifications";
import { INotificationModel } from "@Models/INotificationPayload";

export interface NotificationsListProps {
    isFetching: boolean;
    data: INotificationModel[];
    onActionClick: NotificationItemAction;
    onSetViewedClick: (notificationId: string) => void;
    onFilterClick: (e: RadioChangeEvent) => void;
    onSetAllViewedClick: () => void;
    filter: NotificationsFilter;
}

export const NotificationsList: React.FC<NotificationsListProps> = (props: NotificationsListProps) => {
    return (
        <div className="notifications-dropmenu">
            <div className="notifications-filter">
                <Radio.Group className={"newUI-raised"} onChange={props.onFilterClick} defaultValue="all">
                    <Radio.Button value="all">All</Radio.Button>
                    <Radio.Button value="unread">Unread</Radio.Button>
                </Radio.Group>
            </div>
            {props.filter === "unread" && props.data.length !== 0 && (
                <Button className="secondary" style={{ marginTop: "10px" }} onClick={props.onSetAllViewedClick}>
                    Mark all as read
                </Button>
            )}
            <ul className="notifications-list">
                {props.data.map((notification) => (
                    <NotificationItem
                        onActionClick={props.onActionClick}
                        onSetViewedClick={props.onSetViewedClick}
                        notification={notification}
                        key={notification.notificationId}
                    />
                ))}
            </ul>
        </div>
    );
};
